import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseFileInputKyc from '@/components/v2/BaseFileInputKyc.vue';
import FormValidationMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import KYCDocumentFormMixin from '@/helpers/vue_mixins/v3/KYCDocumentFormMixin';
import KycConfirmationPopup from '@/components/v2/KycConfirmationPopup.vue';
import { requiredIf } from 'vuelidate/lib/validators';
import _ from 'lodash';
import { DocumentType, PrimaryIDs, SecondaryIDs, } from '@/helpers/entities/interfaces/v2/forms/KycFormFields';
import FileAction from '@/plugins/graphql/mutations/v3/file-action.gql';
import SubmitAccountHolder from '@/plugins/graphql/mutations/v3/submit-account-holder.gql';
import DeleteKycFile from '@/plugins/graphql/mutations/v3/delete-kyc-file.gql';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import { Mutation } from 'vuex-class';
let KycDocumentForm = class KycDocumentForm extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, FormValidationMixin, FormMixin, KYCDocumentFormMixin) {
    constructor() {
        super(...arguments);
        this.selectedSelfieType = null;
        this.IdsType = 'primary_id';
        this.isUploading = false;
        this.confirmationModal = false;
        this.isSubmitting = false;
        this.isSaving = false;
        this.fileTypes = 'application/pdf, image/png, image/jpg, image/jpeg';
        this.selfieTypeOptions = [
            {
                text: 'Selfie with Primary ID',
                value: DocumentType.SELFIE_WITH_PRIMARY_ID_DOCUMENT,
            },
            {
                text: 'Selfie with Secondary ID',
                value: DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT,
            },
        ];
        this.IdsTypeOptions = [
            {
                text: 'Primary ID',
                value: 'primary_id',
            },
            {
                text: 'Secondary ID',
                value: 'secondary_id',
            },
        ];
    }
    get primaryIdOptions() {
        if (this.form.businessDetails.type === 'FOREIGN_NONSEC') {
            return [
                {
                    text: _.startCase(DocumentType.AUTHORIZED_PERSON_PASSPORT_DOCUMENT),
                    value: DocumentType.AUTHORIZED_PERSON_PASSPORT_DOCUMENT,
                },
            ];
        }
        return Object.values(PrimaryIDs).map((value) => ({
            text: _.startCase(value),
            value,
        }));
    }
    get secondaryIdsOptions1() {
        return Object.values(SecondaryIDs)
            .map((value) => ({
            text: _.startCase(value),
            value,
        }))
            .filter((option) => option.value !== this.secondaryId2?.documentType &&
            option.value !== this.kycSecondaryId2?.documentType);
    }
    get secondaryIdsOptions2() {
        return Object.values(SecondaryIDs)
            .map((value) => ({
            text: _.startCase(value),
            value,
        }))
            .filter((option) => option.value !== this.secondaryId1?.documentType);
    }
    get selfieWithPrimaryID() {
        if (this.kycDocuments) {
            const selfieWithPrimaryID = this.kycDocuments.find((doc) => doc.documentType === DocumentType.SELFIE_WITH_PRIMARY_ID_DOCUMENT);
            return selfieWithPrimaryID;
        }
        return this.kycSelfieWithPrimaryId;
    }
    get selfieWithSecondaryID() {
        if (this.kycDocuments) {
            const selfieWithSecondaryID = this.kycDocuments.find((doc) => doc.documentType === DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT);
            return selfieWithSecondaryID;
        }
        return this.kycSelfieWithSecondaryId;
    }
    get primaryId() {
        const primaryIdDoc = this.kycDocuments.find((doc) => Object.values(PrimaryIDs).includes(doc.documentType));
        if (primaryIdDoc) {
            this.IdsType = 'primary_id';
            this.kycPrimaryId.documentType = primaryIdDoc.documentType;
            return primaryIdDoc;
        }
        return this.kycPrimaryId;
    }
    get secondaryId1() {
        const secondaryIdDoc1 = this.kycDocuments.find((doc) => doc.documentLabel === 'secondary_id1');
        if (secondaryIdDoc1) {
            this.IdsType = 'secondary_id';
            this.kycSecondaryId1.documentType = secondaryIdDoc1.documentType;
            return secondaryIdDoc1;
        }
        return this.kycSecondaryId1;
    }
    get secondaryId2() {
        const secondaryIdDoc2 = this.kycDocuments.find((doc) => doc.documentLabel === 'secondary_id2');
        if (secondaryIdDoc2) {
            this.IdsType = 'secondary_id';
            this.kycSecondaryId2.documentType = secondaryIdDoc2.documentType;
            return secondaryIdDoc2;
        }
        return this.kycSecondaryId2;
    }
    get dtiRegistration() {
        if (this.kycDocuments) {
            const dtiRegistrationDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.DTI_REGISTRATION_DOCUMENT);
            return dtiRegistrationDoc;
        }
        return this.kycDtiRegistration;
    }
    get bir() {
        if (this.kycDocuments) {
            const bir = this.kycDocuments.find((doc) => doc.documentType === DocumentType.BIR_2303_DOCUMENT);
            return bir;
        }
        return this.kycBir;
    }
    get secCertReg() {
        if (this.kycDocuments) {
            const secCertRegDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.SEC_CERTIFICATE_REGISTRATION_DOCUMENT);
            return secCertRegDoc;
        }
        return this.kycSecCertReg;
    }
    get articleOfPartnership() {
        if (this.kycDocuments) {
            const articleOfPartnershipDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.ARTICLES_OF_PARTNERSHIP_DOCUMENT);
            return articleOfPartnershipDoc;
        }
        return this.kycArticleOfPartnership;
    }
    get notarizePartnerCert() {
        if (this.kycDocuments) {
            const notarizePartnerCertDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.NOTARIZED_PARTNER_CERTIFICATE_DOCUMENT);
            return notarizePartnerCertDoc;
        }
        return this.kycNotarizePartnerCert;
    }
    get notarizeSecCert() {
        if (this.kycDocuments) {
            const notarizeSecCertDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.NOTARIZED_SECRETARY_CERTIFICATE_DOCUMENT);
            return notarizeSecCertDoc;
        }
        return this.kycNotarizeSecCert;
    }
    get latestGIS() {
        if (this.kycDocuments) {
            const latestGISDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.LATEST_GIS_DOCUMENT);
            return latestGISDoc;
        }
        return this.kyclatestGIS;
    }
    get articleOfIncorporation() {
        if (this.kycDocuments) {
            const articleOfIncorporationDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.ARTICLES_OF_INCORPORATION_DOCUMENT);
            return articleOfIncorporationDoc;
        }
        return this.kycArticleOfIncorporation;
    }
    get proofOfCompanyReg() {
        if (this.kycDocuments) {
            const proofOfCompanyRegDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.PROOF_OF_COMPANY_REGISTRATION_DOCUMENT);
            return proofOfCompanyRegDoc;
        }
        return this.kycProofOfCompanyReg;
    }
    get countryIssuedBusinessLicense() {
        if (this.kycDocuments) {
            const countryIssuedBusinessLicenseDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.COUNTRY_ISSUED_BUSINESS_LICENSE_DOCUMENT);
            return countryIssuedBusinessLicenseDoc;
        }
        return this.kycCountryIssuedBusinessLicense;
    }
    get bankBookScan() {
        if (this.kycDocuments) {
            const bankBookScanDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.BANK_BOOK_SCAN_DOCUMENT);
            return bankBookScanDoc;
        }
        return this.kycBankBookScan;
    }
    get serviceAgreement() {
        if (this.kycDocuments) {
            const serviceAgreementDoc = this.kycDocuments.find((doc) => doc.documentType === DocumentType.SERVICE_AGREEMENT_DOCUMENT);
            return serviceAgreementDoc;
        }
        return this.kycServiceAgreement;
    }
    fileName(file) {
        return (!!file && file.name) || null;
    }
    resetPrimaryId(inputType) {
        if (this.primaryId?.file?.blob?.originalUrl) {
            this.kycPrimaryId.documentType = DocumentType.AUTHORIZED_PERSON_PASSPORT_DOCUMENT;
        }
        else {
            this.kycPrimaryId.documentType = null;
        }
        if (!this.secondaryId1?.file?.blob?.originalUrl) {
            this.kycSecondaryId1.documentType = null;
        }
    }
    async handleFileChange(file, document, kycDocument, documentLabel) {
        if (file && file.size > 1024 * 1024 * 8) {
            return this.errorNotification('File size should be less than 8MB');
        }
        kycDocument.isUploading = true;
        try {
            await this.$apollo.mutate({
                mutation: FileAction,
                variables: {
                    input: {
                        file: [file],
                        purpose: 'KYC_DOCUMENT',
                        kycDocumentUuid: document?.uuid || '',
                        accountHolderUuid: this.accountHolderUuid,
                        documentType: document?.documentType || kycDocument.documentType,
                        documentLabel,
                    },
                },
            });
            this.successNotification(`${file.name} uploaded successfully'`);
            this.$emit('refetch-account-holder');
            kycDocument.isUploading = false;
        }
        catch (error) {
            this.errorNotification(error.message);
            kycDocument.isUploading = false;
        }
        kycDocument.isUploading = false;
    }
    handleBack() {
        this.$emit('back');
    }
    async handleRemoveFile(kycDocument, document) {
        kycDocument.isUploading = true;
        try {
            await this.$apollo.mutate({
                mutation: DeleteKycFile,
                variables: {
                    input: {
                        accountHolderUuid: this.accountHolderUuid,
                        kycDocumentUuid: document?.uuid,
                    },
                },
            });
            this.$emit('refetch-account-holder');
            kycDocument.file = null;
            document.file = null;
            kycDocument.isUploading = false;
        }
        catch (error) {
            this.errorNotification(error.message);
            console.log(error);
            kycDocument.isUploading = false;
        }
    }
    async DocumentTypeChange(kycDocument, document, typeOfID) {
        if (typeOfID === 'primary_id') {
            this.$refs.kycPrimaryId.clearFile();
            if (this.form.businessDetails.type === 'FOREIGN_NONSEC') {
                if (this.selfieWithPrimaryID?.file?.blob?.originalUrl) {
                    this.handleRemoveFile(this.kycSelfieWithPrimaryId, this.selfieWithPrimaryID);
                }
            }
        }
        const kycSecondaryId1 = this.$refs.kycSecondaryId1;
        const kycSecondaryId2 = this.$refs.kycSecondaryId2;
        if (typeOfID === 'secondary_id1' && kycSecondaryId1) {
            kycSecondaryId1.clearFile();
        }
        if (typeOfID === 'secondary_id2' && kycSecondaryId2) {
            kycSecondaryId2.clearFile();
        }
        if (document?.file?.blob?.originalUrl) {
            this.handleRemoveFile(kycDocument, document);
        }
    }
    async onConfirm() {
        this.isSubmitting = true;
        try {
            await this.$apollo.mutate({
                mutation: SubmitAccountHolder,
                variables: {
                    input: {
                        accountHolderUuid: this.accountHolderUuid,
                    },
                },
            });
            this.successNotification(`KYC submitted successfully`);
            this.$emit('refetch-account-holder');
            this.isSubmitting = false;
            this.$router.go(-1);
        }
        catch (error) {
            this.errorNotification(error.message);
            this.isSubmitting = false;
        }
    }
    onCancelContinueLater() {
        this.$router.go(-1);
    }
    onContinueLater() {
        this.showConfirmationDialog();
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.confirmationModal = true;
        }
    }
    mounted() {
        this.$emit('refetch-account-holder');
    }
};
__decorate([
    Prop({ type: Object, required: true })
], KycDocumentForm.prototype, "form", void 0);
__decorate([
    Prop({ type: Array, required: true })
], KycDocumentForm.prototype, "kycDocuments", void 0);
__decorate([
    Prop({ type: String, required: false })
], KycDocumentForm.prototype, "accountHolderUuid", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], KycDocumentForm.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], KycDocumentForm.prototype, "hideConfirmationDialog", void 0);
KycDocumentForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseFileInputKyc,
            KycConfirmationPopup,
            ConfirmationDialog,
        },
        validations() {
            const validations = {
                kycSelfieWithPrimaryId: {
                    file: {
                        required: requiredIf(function () {
                            return (this.IdsType === 'primary_id' &&
                                !this.selfieWithPrimaryID?.file?.blob?.originalUrl &&
                                this.form.businessDetails.type !== 'FOREIGN_NONSEC');
                        }),
                    },
                },
                kycPrimaryId: {
                    file: {
                        required: requiredIf(function () {
                            return this.IdsType === 'primary_id' && !this.primaryId?.file?.blob?.originalUrl;
                        }),
                    },
                    documentType: {
                        required: requiredIf(function () {
                            return this.IdsType === 'primary_id';
                        }),
                    },
                },
                kycSelfieWithSecondaryId: {
                    file: {
                        required: requiredIf(function () {
                            return (this.IdsType === 'secondary_id' &&
                                !this.selfieWithSecondaryID?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycSecondaryId1: {
                    file: {
                        required: requiredIf(function () {
                            return this.IdsType === 'secondary_id' && !this.secondaryId1?.file?.blob?.originalUrl;
                        }),
                    },
                    documentType: {
                        required: requiredIf(function () {
                            return this.IdsType === 'secondary_id';
                        }),
                    },
                },
                kycSecondaryId2: {
                    file: {
                        required: requiredIf(function () {
                            return this.IdsType === 'secondary_id' && !this.secondaryId2?.file?.blob?.originalUrl;
                        }),
                    },
                    documentType: {
                        required: requiredIf(function () {
                            return this.IdsType === 'secondary_id';
                        }),
                    },
                },
                kycDtiRegistration: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'SOLE_PROPRIETORSHIP' &&
                                !this.dtiRegistration?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycBir: {
                    file: {
                        required: requiredIf(function () {
                            return (['SOLE_PROPRIETORSHIP', 'PARTNERSHIP', 'CORPORATION'].includes(this.form.businessDetails.type) && !this.bir?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycSecCertReg: {
                    file: {
                        required: requiredIf(function () {
                            return ((this.form.businessDetails.type === 'PARTNERSHIP' ||
                                this.form.businessDetails.type === 'CORPORATION') &&
                                !this.secCertReg?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycArticleOfPartnership: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'PARTNERSHIP' &&
                                !this.articleOfPartnership?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycNotarizePartnerCert: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'PARTNERSHIP' &&
                                !this.notarizePartnerCert?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycNotarizeSecCert: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'CORPORATION' &&
                                !this.notarizeSecCert?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kyclatestGIS: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'CORPORATION' &&
                                !this.latestGIS?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycArticleOfIncorporation: {
                    file: {
                        required: requiredIf(function () {
                            return ((this.form.businessDetails.type === 'CORPORATION' ||
                                this.form.businessDetails.type === 'FOREIGN_NONSEC') &&
                                !this.articleOfIncorporation?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycProofOfCompanyReg: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'FOREIGN_NONSEC' &&
                                !this.proofOfCompanyReg?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycCountryIssuedBusinessLicense: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'FOREIGN_NONSEC' &&
                                !this.countryIssuedBusinessLicense?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycBankBookScan: {
                    file: {
                        required: requiredIf(function () {
                            return (this.form.businessDetails.type === 'FOREIGN_NONSEC' &&
                                !this.bankBookScan?.file?.blob?.originalUrl);
                        }),
                    },
                },
                kycServiceAgreement: {
                    file: {
                        required: requiredIf(function () {
                            return !this.serviceAgreement?.file?.blob?.originalUrl;
                        }),
                    },
                },
            };
            return validations;
        },
    })
], KycDocumentForm);
export default KycDocumentForm;
